export enum SSOState {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
}

type SSOStateMessage = {
    state: SSOState
}

/**
 * SSO Broadcast Channel
 */
export class SSOBC {
    constructor(private bc = new BroadcastChannel("TSN_SSO")) {}

    createSSOStateMessage = (state: SSOState): SSOStateMessage => {
        return {
            state,
        }
    }

    postSSOState = (state: SSOState) => {
        this.bc.postMessage(this.createSSOStateMessage(state))
        return this
    }

    spawnSSOWindow = (config: {
        url: string
        onCancel: () => void
        onState: (state: SSOState) => void
    }) => {
        const h = 600
        const w = 650
        const y = window.outerHeight / 2 + window.screenY - h / 2
        const x = window.outerWidth / 2 + window.screenX - w / 2
        const SSOWindow = window.open(
            config.url,
            "_blank",
            `popup,width=${w},height=${h},top=${y},left=${x}`
        )
        if (SSOWindow) {
            const interval = setInterval(() => {
                if (SSOWindow.closed) {
                    clearInterval(interval)
                    config.onCancel()
                }
            }, 1000)

            new SSOBC().subscribeToSSOState((state) => {
                clearInterval(interval)
                config.onState(state)
                SSOWindow.close()
            })
        }
    }

    subscribeToSSOState = (cb: (state: SSOState) => void) => {
        this.bc.onmessage = (event: MessageEvent<SSOStateMessage>) => {
            cb(event.data?.state)
            this.bc.close()
        }
    }

    close = () => {
        this.bc.close()
    }
}
